const { Application } = Shopware;

Application.addServiceProvider('xpsProductFinderApiService', (container) => {
    const initContainer = Application.getContainer('init');
    
    return new XpsProductFinderApiService(initContainer.httpClient, container.loginService);
});

class XpsProductFinderApiService {
    constructor(httpClient, loginService) {
        this.httpClient = httpClient;
        this.loginService = loginService;
        this.name = 'xpsProductFinderApiService';
    }

    testProductFinder(productFinderId, selections) {
        const apiRoute = '/api/product-finder/' + productFinderId + '/test';
        
        return this.httpClient.post(
            apiRoute,
            { selections },
            {
                headers: this.getBasicHeaders()
            }
        ).then((response) => {
            return response.data;
        });
    }

    getBasicHeaders() {
        return {
            Accept: 'application/vnd.api+json',
            Authorization: `Bearer ${this.loginService.getToken()}`,
            'Content-Type': 'application/json'
        };
    }
}